import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ImpactSection } from '../components/ImpactSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { GallerySection } from '../components/GallerySection';
import { CalendarSection } from '../components/CalendarSection';
import { EmbedsSection } from '../components/EmbedsSection';
import { AlliancesSection } from '../components/AlliancesSection';
import { SponsorsSection } from '../components/SponsorsSection';
import { Footer } from '../components/Footer';

export function LandingPage() {
  return (
    <div className="bg-black min-h-screen" data-testid="landing-page">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ImpactSection />
      <BenefitsSection />
      <GallerySection />
      <CalendarSection />
      <EmbedsSection />
      <AlliancesSection />
      <SponsorsSection />
      <Footer />
    </div>
  );
}
